module.exports = __webpack_public_path__ + "img/conteudos_casas_construcao_17.786008c6.png";